<template>
  <main class="page-content mb-auto w-100 text-center" aria-label="Content">
    <!-- First Container -->
    <div class="section-wrap">
      <div class="section-content">
        <section class="section">
          <div class="header mb-5">
            <h1>Vielen Dank!</h1>
          </div>
          <div class="content">
            <div class="content-center-group donation-wrapper">
              <div class="w-100">
                <h3>Du hast dich bereit erklärt</h3>
                <div class="atom search-selection active mb-3" v-if="selectedCompany">
                  <h4 class="text-white">{{selectedCompany.name}}</h4>
                  <h6 class="font-weight-normal">{{selectedCompany.address}}</h6>
                </div>
                <h3>wieder zu besuchen.</h3>
              </div>
              <div class="text-center mt-4 m-3">
                <p v-if="donation && donation.hideMessage" class="if-on">Deine Message haben wir auf der COVIDA - Seite deines Lieblingsladens gepostet. Du kannst deine Unterstützung auch auf den Sozialen Medien teilen:</p>              </div>
              <div class="section-wrap">
                <div class="section-content">
                  <div class="content-center-group" v-if="donationId">
                    <!-- <ticket-component :id="donationId" /> -->
                    <div class="ticket for-company">
                      <div class="left-side">
                        <div class="bg"></div>
                        <div class="badge">
                          <div class="title">
                            CORONA
                            <br />Solidarität
                          </div>
                          <div class="hashtag">#solidarity4kmu</div>
                          <div class="link">www.covida.ch</div>
                        </div>
                      </div>
                      <div class="right-side text-center mt-0"  style="font-size: 14px;">
                        <div class="title mb-2" style="height: auto; line-height: 18px">Ich freue mich darauf wenn</div>
                        <b class=" mb-2" style="line-height: 20px;">
                          {{selectedCompany.name}}
                          <br />wieder öffnet!
                        </b>
                        
                        <div class="place" style="line-height: 18px">
                          du auch? <br/>
                          www.covida.ch</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-center mt-5 m-3">
                <h5>Teile es mit deinen Freunden</h5>
                <div class="social-button-group">
                  <social-sharing :url=getUrlParam
                  hashtags="solidarity4kmu"
                  inline-template>
                    <div>
                      <network network="facebook">
                        <button class="btn btn-icon facebook">
                          <i class="stg st-social-media-facebook-1"></i>Share on Facebook
                        </button>
                      </network>
                    </div>
                  </social-sharing>
                  <social-sharing :url=getUrlParam
                    hashtags="solidarity4kmu"
                    inline-template>
                    <div>
                      <network network="twitter">
                        <button class="btn btn-icon twitter">
                        <i class="stg st-social-media-twitter"></i>Share on Twitter
                      </button>
                      </network>
                    </div>
                  </social-sharing>
                  <social-sharing
                    :url=getUrlParam
                    hashtags="solidarity4kmu"
                    inline-template
                    >
                    <div>
                      <network network="whatsapp">
                    <button class="btn btn-icon whatsapp">
                        <i class="stg st-messaging-whatsapp"></i>Share on Whatsapp
                      </button>
                      </network>
                    </div>
                  </social-sharing>
                </div>
              </div>
              <div>
                <h5 class="mt-5 mb-3 d-block">Dein Soli-Beitrag</h5>
                <div>Damit du später noch weisst, welchen Soli-Beitrag du leisten wolltest, haben wir dir einen Soli-Batch in deinem Profil abgelegt. Klicke oben rechts auf deinen Namen um zu deinem Profil zu gelangen.</div>
              </div>
              <div class="text-center d-flex align-items-center flex-column mt-3 donation-wrapper">
                <button
                  type="button"
                  v-on:click="goToCompaniesList"
                  class="btn btn-primary mt-5 support-btn"
                >Noch mehr unterstützen</button>
                <button
                  v-if="loggedIn"
                  v-on:click="goToUserProfileList"
                  type="button"
                  class="btn btn-secondary mt-2 support-btn"
                >Zu deinem Profil</button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </main>
</template>

<script>
import { mapGetters } from "vuex";
// import Ticket from "@/components/Ticket.vue";
import firebase from "firebase/app";
let db = firebase.firestore();
let donationsRef = db.collection("donations");

export default {
  props: ["companyId", "donationId"],
  data: function(){
    return {
      company: null,
      donation: null,
      over100: true
    }
  },
  mounted: function(){
     let $this = this;
    donationsRef
      .doc(this.donationId)
      .get()
      .then(function(querySnapshot) {
        if (!querySnapshot.exists) {
          return;
        }
        $this.donation = querySnapshot.data();
      })
      .catch(function(error) {
        console.log("Error getting documents: ", error);
      });
  },
  components: {
    // ticketComponent: Ticket
  },
  computed: {
    ...mapGetters({
      loggedIn: "loggedIn",
      selectedCompany: "selectedCompany"
    }),
    getUrlParam: function () {
        if(this.selectedCompany!=null){
          return process.env.VUE_APP_service_sharing_url + "sharing/donation?companyname="+this.selectedCompany.name;
        }
        return "";   
    }
  },
  methods: {
    goToCompaniesList: function() {
      if (this.loggedIn) {
        this.$router.push({
          path: "/donation/companies/list"
        });

        return;
      }

      this.$router.push({
        path: "/companies/list"
      });
    },

    goToUserProfileList: function() {
      if (this.loggedIn) {
        this.$router.push({
          path: "/user/profile"
        });

        return;
      }
    }
  }
};
</script>

<style>
</style>
